import * as React from 'react'
import { Link, Route, Switch, RouteComponentProps } from 'react-router-dom'
import LocationPane from '../../../containers/riders/riderdetails/LocationPane'
import MembershipPane from '../../../containers/riders/riderdetails/MembershipPane'
import PersonalInfoPane from '../../../containers/riders/riderdetails/PersonalInfoPane'
import WalletPane from '../../../containers/riders/riderdetails/WalletPane'
import RecurringTripsPane from '../../../containers/riders/riderdetails/RecurringTripsPane'
import AppliedPromotionsPane from './promotions/AppliedPromotionsPane'
import { IRiderObject } from '../../../types'
import UIMessages from '../../../utils/ui-messages'
import RiderProfileStepSelector from './RiderProfileStepSelector'
import ButtonWithBtn from '../../ui/ButtonWithIcon'
import Archive from '../../icons/ui/Archive'
import Restore from '../../icons/ui/RestoreArchive'
import Edit from '../../icons/ui/Edit'
import Deactivate from 'src/components/icons/vehicle/Deactivate'
import Activate from 'src/components/icons/vehicle/Activate'
import RiderChangeLog from 'src/containers/riders/riderdetails/RiderChangeLog'
import DriverFeedback from 'src/containers/riders/riderdetails/DriverFeedback'
import BackToList from 'src/components/ui/BackToList'
import PreloaderCircle from 'src/components/ui/PreloaderCircle'
import RiderFeedback from 'src/containers/riders/riderdetails/RiderFeedback'
import ButtonBlueWithIcon from 'src/components/ui/ButtonBlueWithIcon'

interface IParams {
  id: string
}

interface IRiderProfilePaneProps extends RouteComponentProps<IParams> {
  riders: { [key: string]: IRiderObject }
  loading: boolean
  activate: (rider: IRiderObject) => void
  archive: (rider: IRiderObject) => void
  restore: (rider: IRiderObject) => void
  deactivate: (rider: IRiderObject) => void
  getRiderPersonalInfo: (riderId: string) => void
}

interface IRiderProfileStepsPaneProps extends RouteComponentProps<IParams> {
  rider: any
}

const RiderProfileStepsPane = ({ match, location, rider }: IRiderProfileStepsPaneProps) => {
  const riderId = match.params.id

  const personalInfoPane = (props: any) => {
    return <PersonalInfoPane rider={rider} {...props} />
  }

  const recurringTripsPane = (props: any) => {
    return <RecurringTripsPane riderId={riderId} {...props} />
  }

  const membershipPane = (props: any) => {
    return <MembershipPane riderId={riderId} {...props} />
  }

  const walletPane = (props: any) => {
    return <WalletPane rider={rider} {...props} />
  }

  const locationPane = (props: any) => {
    return <LocationPane riderId={riderId} {...props} />
  }

  const appliedPromotionsPane = (props: RouteComponentProps) => {
    return <AppliedPromotionsPane {...props} riderId={riderId} />
  }

  const riderChangeLog = (props: any) => {
    return <RiderChangeLog riderId={riderId} />
  }

  const driverFeedback = (props: any) => {
    return <DriverFeedback riderId={riderId} />
  }

  const riderFeedback = (props: any) => {
    return <RiderFeedback riderId={riderId} />
  }

  return (
    <div>
      <RiderProfileStepSelector pathname={location.pathname} riderId={riderId} />
      <Switch>
        <Route path={`/riders/${riderId}/profile/info`} render={personalInfoPane} />
        <Route path={`/riders/${riderId}/profile/recurringTrips`} render={recurringTripsPane} />
        <Route path={`/riders/${riderId}/profile/membership`} render={membershipPane} />
        <Route path={`/riders/${riderId}/profile/wallet`} render={walletPane} />
        <Route path={`/riders/${riderId}/profile/location`} render={locationPane} />
        <Route path={`/riders/${riderId}/profile/promotions`} render={appliedPromotionsPane} />
        <Route path={`/riders/${riderId}/profile/changeLog`} render={riderChangeLog} />
        <Route path={`/riders/${riderId}/profile/driverFeedback`} render={driverFeedback} />
        <Route path={`/riders/${riderId}/profile/riderFeedback`} render={riderFeedback} />
      </Switch>
    </div>
  )
}

interface IRiderProfileState {
  isLoading: boolean
}
class RiderProfilePane extends React.Component<IRiderProfilePaneProps, IRiderProfileState> {
  public state = {
    isLoading: true
  }

  public async componentDidMount() {
    try {
      await this.props.getRiderPersonalInfo(this.props.match.params.id)
    } finally {
      this.setState({
        isLoading: false
      })
    }
  }

  public render() {
    console.log('Inside here in the Rider Profile Pane')

    const riderId = this.props.match.params.id
    const rider = this.props.riders[riderId]
    const fullName = rider ? `${rider.firstName} ${rider.lastName}` : ''
    const isActive = rider && rider.isActive
    const isArchived = rider && rider.isArchived

    const styles = {
      CirclePreLoader: {
        display: 'flex',
        paddingTop: '5px',
        flex: 1,
        justifyContent: 'center',
        alignment: 'center',
        width: '100%'
      }
    }

    if (this.state.isLoading) {
      return (
        <div style={styles.CirclePreLoader}>
          <PreloaderCircle loading={true} />
        </div>
      )
    }

    return (
      <section>
        <BackToList link='/riders' className='flex' />
        <div className='justify-between form-title-header no-border'>
          <div>
            <span className='h3 font-blue-grey'>{fullName}</span>
            <span className='ml2 h5'>
              {UIMessages.common.status}: {isActive ? UIMessages.common.active : UIMessages.common.inactive}
            </span>
          </div>
          {!isArchived ? (
            <div className='flex ml-auto mr2'>
              <Link className='btn bg-green rounded mr2' to={`/trips/recent/${riderId}`}>
                <span className='font-white weight-300'>{UIMessages.common.NewRequest}</span>
              </Link>
              <Link to={this.redirectPath()}>
                <ButtonBlueWithIcon title={'Edit'}>
                  <Edit className='icon--16x16' />
                </ButtonBlueWithIcon>
              </Link>
              <div className='cursor--pointer' onClick={this.onArchive(rider)}>
                <ButtonWithBtn title={UIMessages.common.moveToArchive}>
                  <Archive className='icon--small' />
                </ButtonWithBtn>
              </div>
              {isActive ? (
                <div className='cursor--pointer' onClick={this.onDeactivate(rider)}>
                  <ButtonWithBtn title={UIMessages.common.deactivate}>
                    <Deactivate className='icon--small' />
                  </ButtonWithBtn>
                </div>
              ) : (
                <div className='cursor--pointer' onClick={this.onActivate(rider)}>
                  <ButtonWithBtn title={UIMessages.common.activate}>
                    <Activate className='icon--small' />
                  </ButtonWithBtn>
                </div>
              )}
            </div>
          ) : (
            <div className='cursor--pointer mr2' onClick={this.onRestore(rider)}>
              <ButtonWithBtn title={UIMessages.common.restoreFromArchive}>
                <Restore className='icon--small' />
              </ButtonWithBtn>
            </div>
          )}
        </div>
        <RiderProfileStepsPane rider={rider} {...this.props} />
      </section>
    )
  }

  private onDeactivate = (rider: IRiderObject) => () => {
    this.props.deactivate(rider)
  }

  private onActivate = (rider: IRiderObject) => () => {
    this.props.activate(rider)
  }

  private onArchive = (rider: IRiderObject) => () => {
    this.props.archive(rider)
  }

  private onRestore = (rider: IRiderObject) => () => {
    this.props.restore(rider)
  }

  private redirectPath = () => {
    const { location, match } = this.props
    const riderId = this.props.match.params.id

    if (/\/info/.test(location.pathname)) {
      return `/riders/${riderId}/edit/profile`
    } else if (/\/location/.test(location.pathname)) {
      return `/riders/${riderId}/edit/location`
    } else if (/\/membership/.test(location.pathname)) {
      return `/riders/${riderId}/edit/membership`
    } else if (/\/wallet/.test(location.pathname)) {
      return `/riders/${riderId}/edit/wallet`
    }
    return location.pathname
  }
}

export default RiderProfilePane



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/RiderProfilePane.tsx